<qv-action-menu [menuActionItems]="reviewMenuItems"></qv-action-menu>